import TextField from "@mui/material/TextField"
import React, { useMemo } from "react"

export default function InputText({
	label,
	required,
	fullWidth,
	onChange,
	value,
	setValue,
	disabled,
	multiline,
	rows,
	minRows,
	maxRows,
}) {
	const props = { label, value, required, fullWidth, multiline, rows, minRows, maxRows }

	const handleChange = useMemo(
		() => (setValue ? (event) => setValue(event.target.value) : onChange),
		[onChange, setValue]
	)

	return (
		<TextField
			onChange={handleChange}
			disabled={disabled}
			{...props}
			variant="outlined"
			size="small"
			// defaultValue={value}
		/>
	)
}
